<img *ngIf="!isFavorited" class="favorite-icon" (click)="favorite()" src="/assets/icons/icons8-bookmark_outline.svg"  />
<img *ngIf="isFavorited" class="favorite-icon" (click)="unfavorite()" src="/assets/icons/icons8-bookmark_filled.svg" />
